export type IPublicTypeDOMText = string;
